import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=639b9f9a&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"
import style0 from "./Invoice.vue?vue&type=style&index=0&id=639b9f9a&prod&lang=css"
import style1 from "./Invoice.vue?vue&type=style&index=1&id=639b9f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b9f9a",
  null
  
)

export default component.exports